import {
  SET_STEP_ONE_DATA,
  SET_STEP_TWO_DATA,
  RESET_USER_UPDATE_DATA,
  LOAD_USER_DATA,
  LOAD_USER_DATA_FROM_STORAGE,
  SET_IS_FORM_CHANGED,
  SET_STEPS_CHANGED,
  SAVE_FORM_DATA_TO_STORAGE,
  UPDATE_STORE_DATA,
} from './UserUpdate.constant';
import { IUserCreateForm } from 'entities/view/userCreate';
import { IStepOneForm, UserUpdateActionsTypes } from './UserUpdate.type';

export const setStepOneData = (payload: IStepOneForm): UserUpdateActionsTypes => ({
  type: SET_STEP_ONE_DATA,
  payload,
});

export const setStepTwoData = (
  payload: IUserCreateForm,
): UserUpdateActionsTypes => ({
  type: SET_STEP_TWO_DATA,
  payload,
});

export const resetUserUpdateData = (): UserUpdateActionsTypes => ({
  type: RESET_USER_UPDATE_DATA,
});

export const loadUserData = (payload: {
  userId: number;
  stepOne: IStepOneForm;
  stepTwo: IUserCreateForm;
  skipLocalStorageSave?: boolean;
}): UserUpdateActionsTypes => ({
  type: LOAD_USER_DATA,
  payload,
});

export const loadUserDataFromStorage = (
  userId: number,
): UserUpdateActionsTypes => ({
  type: LOAD_USER_DATA_FROM_STORAGE,
  payload: { userId },
});

export const setUserUpdateFormIsChanged = (payload: boolean) => ({
  type: SET_IS_FORM_CHANGED,
  payload,
});

export const setUserUpdateStepsChanged = (payload: {
  isStepOneChanged: boolean;
  isStepTwoChanged: boolean;
}): UserUpdateActionsTypes => ({
  type: SET_STEPS_CHANGED,
  payload,
});

export const saveFormDataToStorage = (stepTwoData: any): UserUpdateActionsTypes => ({
  type: SAVE_FORM_DATA_TO_STORAGE,
  payload: stepTwoData,
});

export const updateStoreData = (payload: {
  userId: number;
  stepOne: IStepOneForm;
  stepTwo: IUserCreateForm;
}): UserUpdateActionsTypes => ({
  type: UPDATE_STORE_DATA,
  payload,
});
